import Fuse from 'fuse.js'
import _ from 'lodash'

export const fuseSearch = (items = [], keys = [], searchTerm = '') => {
  if (_.isEmpty(searchTerm)) return items
  const fuse = new Fuse(items, { keys })
  const result = fuse.search(searchTerm)
  return result.map(i => i.item)
}
